export default {
      id: "ic_info_darkgrey-usage",
      viewBox: "0 0 13 13",
      url: "/" + "images/icons.3.109.2.svg#ic_info_darkgrey-usage",
      toString: function () {
        return this.url;
      }
    }